import { useAppSelector } from '../features';

export const usePermission = (requiredPermission: string | string[]) => {
    // TODO: Change it to RTK Query Hook to get loading status
    const { permissions, isAuthenticated, role } = useAppSelector(
        (state) => state.auth.user,
    );

    const isAdmin = role.name === 'Admin';

    let hasPermission = false;

    if (!isAuthenticated) {
        hasPermission = false;
    } else if (!permissions) {
        hasPermission = false;
    } else if (
        permissions.some((permission) =>
            Array.isArray(requiredPermission)
                ? requiredPermission.includes(permission)
                : requiredPermission === permission,
        )
    ) {
        hasPermission = true;
    } else {
        hasPermission = false;
    }

    return {
        hasPermission,
        isAdmin,
    };
};
